// extracted by mini-css-extract-plugin
module.exports = {"LoginCard":"styles_LoginCard__3C64b","LoginCardClose":"styles_LoginCardClose__2mVVZ","LoginCardTitle":"styles_LoginCardTitle__2FQwd"};